import React, { Component } from "react";
import "../assets/js/swiped.min";
class Notification extends Component {

    componentDidMount() {
        var a1 = window.Swiped.init({
            query: '.swipeItem li',
            left: 400,
            onOpen: function () {
                this.destroy(true)
            },
            onClose: function () {
                console.log('close')
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <div class="container mt-45">
                    <div class="row">
                        <div class="col-12">
                            <h4>Notifications</h4>
                        </div>
                    </div>

                    <ul class="swipeItem">
                        <li>
                            <div class="card border-success mb-3">
                                <div class="card-header bg-success text-white"><i class="fas fa-check mr-2"></i>Félicitations !</div>
                                <div class="card-body">
                                    <p class="card-text">Vous avez ajouté une établissement avec succès. Ajouté 18 autres établissement pour gagner un repas dans un établissement.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card border-danger mb-3">
                                <div class="card-header bg-danger text-white"><i class="fas fa-exclamation-triangle mr-2"></i>Erreur !</div>
                                <div class="card-body">
                                    <p class="card-text">Les informations soumisent ne sont pas correctes, veuillez revoir le formulaire et apporter des modifications. </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card border-info mb-3">
                                <div class="card-header bg-info text-white"><i class="fas fa-info-circle mr-2"></i>Envie d'un verre ?</div>
                                <div class="card-body">
                                    <p class="card-text">Envie de prendre un verre ? il ya des établissements intérréssant proche de votre position actuelle.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card border-success mb-3">
                                <div class="card-header bg-success text-white"><i class="fas fa-check mr-2"></i>Félicitations !</div>
                                <div class="card-body">
                                    <p class="card-text">Vous avez ajouté une établissement avec succès. Ajouté 20 établissements pour gagner un repas dans un établissement.</p>
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>
            </React.Fragment>
        );
    }
}

export default Notification;